import React from 'react';
import { Card, CardHeader, CardContent, Avatar, IconButton, Typography, Alert, Box, Button, Skeleton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { blue } from '@mui/material/colors';

const ManagementStockCard = ({
  stockProducts = [],
  onRefresh,
  onAddToStock,
  expectedSku = '',
}) => {
  const normalizeSku = (value = '') => String(value || '').replace(/\s+/g, '').trim().toUpperCase();
  const normalizedExpectedSku = normalizeSku(expectedSku);
  const visibleProducts = normalizedExpectedSku
    ? stockProducts.filter((product) => normalizeSku(product.sku) === normalizedExpectedSku)
    : [];
  const isSkuMissing = !normalizedExpectedSku;

  return (
    <Card sx={{ width: '100%', marginBottom: 2, backgroundColor: 'rgba(173, 255, 47, 0.08)' }}>
      <CardHeader
        avatar={<Avatar sx={{ bgcolor: blue[500] }} aria-label="sortly">MS</Avatar>}
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            Management Stock (Sortly)
            <IconButton size="small" onClick={() => onRefresh?.()} disabled={isSkuMissing} sx={{ color: '#1E90FF' }} title="Reîncarcă">
              <RefreshIcon fontSize="small" />
            </IconButton>
          </Box>
        }
      />
      <CardContent>
        <Typography variant="body2" sx={{ mb: 1 }}>
          SKU Ciorna JIRA 10083: {expectedSku || 'N/A'}
        </Typography>

        {isSkuMissing && (
          <Alert severity="warning" sx={{ marginBottom: 2 }}>
            Completează mai întâi SKU Ciorna în JIRA 10083. Fără acest SKU nu afișăm produse Sortly și nu permitem adăugarea în stoc.
          </Alert>
        )}

        {visibleProducts.length > 0 ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {visibleProducts.map((product, index) => (
              <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2, borderBottom: '1px solid #ccc', paddingBottom: 1 }}>
                {product.image_url ? (
                  <img src={product.image_url} alt={product.product_name} style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 4 }} onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; }} />
                ) : (
                  <Skeleton variant="rectangular" width={100} height={100} />
                )}
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">{product.product_name}</Typography>
                  <Typography variant="body2">Preț: {product.price} RON</Typography>
                  <Typography variant="body2">SKU: {product.sku || 'N/A'}</Typography>
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <Alert severity="info" sx={{ marginTop: 2, backgroundColor: '#FFF8E1', color: '#795548' }}>
            {isSkuMissing ? 'Nu putem verifica stocul fără SKU Ciorna.' : 'Niciun produs în stoc pentru SKU-ul acestei cereri.'}
          </Alert>
        )}

        {visibleProducts.length === 0 && (
          <Box sx={{ textAlign: 'center', marginTop: 2 }}>
            <Button variant="contained" color="success" onClick={onAddToStock} disabled={isSkuMissing} sx={{ backgroundColor: '#32CD32', color: 'white', fontWeight: 'bold', padding: '10px 20px', '&:hover': { backgroundColor: '#228B22' } }}>
              Adaugă în stoc
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ManagementStockCard;
